import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class Error403Interceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
    private readonly auth: AuthService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          console.error('HTTP 403 Forbidden Error:', error);
          this.auth.loginError = 'LOGIN_PAGE.ERROR.PERMISSIONS';
          this.auth.logoutNew();
        }

        return throwError(() => error);
      })
    );
  }
}
